






import AbpBase from '../../../lib/abpbase';
import { Component, Vue,Inject } from 'vue-property-decorator';
import util from '@/lib/util';
import LinkUserWechat from '@/views/setting/user/link-user-wechat.vue';
@Component({
   components:{LinkUserWechat}
})
export default class WxChatBindLogin extends AbpBase {
 messageTxt:'页面加载中，或尝试重新扫码登录'
 wxloginModel={
     userNameOrEmailAddress:'',
     password:'',
     unionId:'',
     openId:'',
     nickName:'',
     headImgUrl:''
 }

  async wxbind(){
     let result=await this.$store.dispatch({
       type:'user/bindWechat',
       data:this.wxloginModel
     }); 
     if(result){
         await this.$store.dispatch({ type:'session/init'});
         await this.$Modal.info({
             title: this.L('提示'),
             content: "微信绑定已完成,请尝试重新扫码登录。",
             onOk: () => {
                 this.$store.commit('app/logout', this);
                 util.abp.auth.clearToken();
                 location.reload();
             }
         });
     }
     else{
         this.$Modal.error({title:this.L('Error'),content:this.L('绑定失败')});
         return;
     }      
 }
async mounted() {
   const code=this.$route.query.code;
   if(code&&code!==""){
     this.wxloginModel.unionId=JSON.parse(code).unionid;
     this.wxloginModel.openId=JSON.parse(code).openid;
     this.wxloginModel.nickName=JSON.parse(code).nickname;
     this.wxloginModel.headImgUrl=JSON.parse(code).headimgurl;
     this.$router.push({ query: {} });
    await this.wxbind();
   }
 }
 created () {  
 }
}
